// extracted by mini-css-extract-plugin
export default {"container":"General_container__t37FL","contentWrapper":"General_contentWrapper__tW8IR","header":"General_header__oL4ch","emailLink":"General_emailLink__IGWAk"};